import { CONSENT_REQUIRED_MESSAGE, validateConsentValue, validateEmailValue, validateNameValue } from "./validation.js";

/**
 * Body of POST /api/waitlist.
 *
 * @param {unknown} emailRaw
 * @param {{ name?: string, whatsapp?: boolean, consent: boolean, consentVersion: string, company: string, source?: string }} meta
 */
export function buildSignupPayload(emailRaw, meta) {
  const message = validateEmailValue(emailRaw);
  if (message) {
    return { ok: false, code: "email_invalid", message, field: "email" };
  }

  const nameMessage = validateNameValue(meta.name);
  if (nameMessage) {
    return { ok: false, code: "name_invalid", message: nameMessage, field: "name" };
  }

  const consentMessage = validateConsentValue(meta.consent);
  if (consentMessage) {
    return {
      ok: false,
      code: "consent_required",
      field: "consent",
      message: CONSENT_REQUIRED_MESSAGE,
    };
  }

  const payload = {
    email: String(emailRaw).trim().toLowerCase(),
    whatsapp: meta.whatsapp === true,
    consent: true,
    consent_version: meta.consentVersion,
    source: meta.source ?? "web",
    company: meta.company ?? "",
  };

  const trimmedName =
    meta.name !== undefined && meta.name !== null ? String(meta.name).trim() : "";
  if (trimmedName) {
    payload.name = trimmedName;
  }

  return { ok: true, payload };
}
